import {Box, Grid, Typography, useTheme} from '@mui/material';
import {useState} from 'react';
import useLoadAds from '@jobseeker/common-core/hooks/useLoadAds';

import {useIsLargeDevice} from '@jobseeker/lotus/hooks';

import type {AdsElementType} from '@jobseeker/common-core/types';
import {Image} from '@jobseeker/lotus/components/Image';
import WinnersAvatar from './WinnersAvatar';
import {useSelector} from 'react-redux';
import {AppState} from '@jobseeker/common-core/stores';

const WinnerPageBanner = () => {
  const {
    timelines: {ads},
  } = useSelector((state: AppState) => state.competition);

  const slotId = ads?.winnerPageBanner?.slotId ?? '';
  const winnersSlotId = ads?.winners?.slotId ?? '';

  const [bannerInfo, setBannerInfo] = useState(Array<AdsElementType>);
  const [epochWinners, setEpochWinners] = useState(Array<AdsElementType>);

  useLoadAds(slotId, setBannerInfo, {}, false);
  useLoadAds(winnersSlotId, setEpochWinners, {}, false);
  const isAboveMobile = useIsLargeDevice('sm');

  const theme = useTheme();

  return (
    <Box
      maxWidth={1440}
      ml="auto"
      mr="auto"
      textAlign="center"
      color="#000"
      sx={{backgroundColor: theme.palette.secondary.contrastText}}
    >
      <Box
        id="competition-banner"
        sx={{
          height: {xs: '560px', md: '820px'},
          px: 3.125,
          background: `url(${
            isAboveMobile ? bannerInfo[0]?.imageUrl : bannerInfo[2]?.imageUrl
          }) no-repeat`,
          backgroundColor: '#fff',
          display: 'flex',
          flexDirection: 'column',
          position: 'sticky',
          alignItems: 'center',
          backgroundSize: '100% 100%',
        }}
      >
        <Image
          src={
            isAboveMobile
              ? bannerInfo?.[3]?.imageUrl
              : bannerInfo?.[5]?.imageUrl
          }
          width={isAboveMobile ? 618 : 309}
          height={isAboveMobile ? 260 : 130}
          alt="EPOCH"
          style={{margin: `${isAboveMobile ? '172px' : '100px'} 0 28px`}}
        />
        <Typography
          fontSize={theme.typography.pxToRem(isAboveMobile ? 20 : 16)}
          color={theme.palette.primary.contrastText}
          maxWidth={970}
        >
          The below students showed exemplary problem-solving skills, strategic
          acumen, and innovative thinking setting them apart in a field of
          highly talented participants.
        </Typography>
      </Box>

      <Box position="relative" top={-150} px={1}>
        {isAboveMobile ? (
          <Grid container direction="row" justifyContent="space-evenly">
            <Grid item>
              <WinnersAvatar winnerData={{rank: 2, ...epochWinners?.[1]}} />
            </Grid>
            <Grid item position="relative" top={-80}>
              <WinnersAvatar winnerData={{rank: 1, ...epochWinners?.[0]}} />
            </Grid>
            <Grid item>
              <WinnersAvatar winnerData={{rank: 3, ...epochWinners?.[2]}} />
            </Grid>
          </Grid>
        ) : (
          <Grid container direction="column">
            <Grid item>
              <WinnersAvatar winnerData={{rank: 1, ...epochWinners?.[0]}} />
            </Grid>
            <Grid item mt={-5}>
              <WinnersAvatar winnerData={{rank: 2, ...epochWinners?.[1]}} />
            </Grid>
            <Grid item>
              <WinnersAvatar winnerData={{rank: 3, ...epochWinners?.[2]}} />
            </Grid>
          </Grid>
        )}
        <Typography
          fontWeight={600}
          fontSize={theme.typography.pxToRem(isAboveMobile ? 32 : 20)}
        >
          Other 7 Best Entries with prize money of 50k each
        </Typography>
        <Typography
          fontWeight={300}
          fontSize={theme.typography.pxToRem(isAboveMobile ? 16 : 13)}
        >
          The iimjobs&apos; team will reach out to the participants for prize
          disbursal process
        </Typography>
        <Grid
          container
          gap={6.25}
          mt={4.25}
          sx={
            isAboveMobile
              ? {
                  justifyContent: 'center',
                }
              : {
                  width: '100%',
                  justifyContent: 'flex-start',
                  display: 'flex',
                  whiteSpace: 'nowrap',
                  flexWrap: 'nowrap',
                  overflowX: 'auto',
                  paddingLeft: '1rem',
                  scrollSnapType: 'x mandatory',
                  '&::-webkit-scrollbar': {
                    height: '8px',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    backgroundColor: '#888',
                    borderRadius: '4px',
                  },
                  '&::-webkit-scrollbar-track': {
                    backgroundColor: '#f0f0f0',
                  },
                }
          }
        >
          {epochWinners?.slice(3, 10)?.map((data, index) => (
            <Grid
              item
              key={`${index}-${data.title?.[0]}`}
              sx={{
                flex: '0 0 auto',
                scrollSnapAlign: 'start',
              }}
            >
              <WinnersAvatar winnerData={{rank: index + 4, ...data}} />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default WinnerPageBanner;
